import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

export const noti: {
  message: MessageInstance;
  notification: NotificationInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
} = {} as {
  message: MessageInstance;
  notification: NotificationInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
};

export function Noti() {
  const staticFunction = App.useApp();
  noti.message = staticFunction.message;
  noti.notification = staticFunction.notification;
  noti.modal = staticFunction.modal;

  return null;
}
